// removed by extract-text-webpack-plugin
module.exports = {"digest":"src-pages----digest-module---digest---2DH0v","link":"src-pages----digest-module---link---28nfd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/digest.module.scss
// module id = 254
// module chunks = 79813120194986